// 页面权限
export const BRAND_LIST_PAGE_UUID = '301a731c-cabd-42b3-851b-8ac811efbef7'
// 操作权限
export const BRAND_ACTION_UUID = '0d63a521-947e-48c6-af00-c982289b8238'
